var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "19.6px",
    height: "40.3px",
    viewBox: "0 0 19.6 40.3",
    enableBackground: "new 0 0 19.6 40.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_new",
    transform: "translate(-365.999 -262.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_679",
    transform: "translate(374.999 270.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_661",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1761-2",
    fill: "#FFFFFF",
    d: "M9.8,40.2H8.5v0.2c-1.1,0-2.1-0.2-3.2-0.4c-6-1.4-3.4-11.9-3.4-11.9 c-0.3-5-0.4-10,0-15c-0.6,0.1-1.3,0.3-1.8,0.6C0,12.8,1.3,12,1.3,12C1,9.8,1,7.7,1.3,5.5C2-0.5,9.8,0,9.8,0s7.8-0.5,8.5,5.5 c0.2,2.1,0.2,4.3,0,6.4c0,0,1.3,0.9,1.3,1.7c-0.6-0.3-1.2-0.5-1.8-0.6c0.3,5,0.3,10,0,15c0,0,2.6,10.5-3.4,11.9 c-1,0.2-2.1,0.4-3.2,0.4v-0.2H9.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_662",
    transform: "translate(16.571 12.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1762",
    fill: "#3A3A3A",
    d: "M-8.2-8L-9-2.2v7.6l0.8,5.8V-8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_663",
    transform: "translate(8.979 0.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1763",
    fill: "#A7A9AC",
    d: "M-7.3-7.6c0,0.2-0.4,0.4-0.8,0.4S-9-7.4-9-7.6S-8.6-8-8.2-8S-7.3-7.8-7.3-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_664",
    transform: "translate(8.979 38.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1764",
    fill: "#A7A9AC",
    d: "M-7.3-7.6c0,0.2-0.4,0.4-0.8,0.4S-9-7.4-9-7.6S-8.6-8-8.2-8S-7.3-7.8-7.3-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_665",
    transform: "translate(15.208 15.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1765",
    fill: "#4C4C4C",
    d: "M-8.9,6C-9,1.3-8.8-3.4-8.2-8l0.2,0C-8.6-3.4-8.9,1.3-8.8,6L-8.9,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_666",
    transform: "translate(8.082 37.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1766",
    fill: "#F21947",
    d: "M-5.6-7.9c0,0.1-0.1,0.1-0.1,0.1h-3.2C-8.9-7.7-9-7.8-9-7.9l0,0 C-9-7.9-8.9-8-8.9-8h3.2C-5.6-8-5.6-7.9-5.6-7.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_667",
    transform: "translate(16.523 3.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1767",
    fill: "#4C4C4C",
    d: "M-8-0.6l0-0.2c0.6-0.1,0.6-2.4,0.5-3.8C-7.6-5.8-8.1-7-9-7.9L-8.9-8 C-8-7.1-7.4-5.9-7.4-4.6C-7.4-4.2-7.1-0.7-8-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_668",
    transform: "translate(1.602 0.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1768",
    fill: "#4C4C4C",
    d: "M7.1,4.5C7,4.2,7.1,3.9,7.2,3.6L6.8,3.5V3.4C7-0.9,4.4-5.4,4.4-5.5 C3-8-0.8-7.9-0.8-7.9S-4.6-8-6-5.5c0,0-2.6,4.6-2.4,8.9v0.1l-0.4,0.2c0.1,0.3,0.1,0.6,0.1,0.9l-0.2,0c0.1-0.3,0-0.6-0.1-0.9 l0-0.1l0.4-0.2c-0.2-4.3,2.4-8.9,2.4-8.9C-4.7-8.1-0.8-8-0.8-8s3.9-0.1,5.3,2.5c0,0,2.6,4.6,2.4,8.9l0.4,0.2l0,0.1 C7.2,3.9,7.2,4.2,7.2,4.5L7.1,4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_669",
    transform: "translate(2.236 12.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1769",
    fill: "#3A3A3A",
    d: "M-9-8l0.8,5.8v7.6L-9,11.2V-8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_670",
    transform: "translate(2.203 36.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1770",
    fill: "#F21947",
    d: "M-8.9-7.9C-8.7-8.1-8.1-8-7.5-7.6s0.9,1,0.7,1.2s-0.8,0.2-1.4-0.3 S-9.1-7.6-8.9-7.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_671",
    transform: "translate(15.176 36.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1771",
    fill: "#F21947",
    d: "M-6.8-7.9C-7-8.1-7.7-8-8.2-7.6s-0.9,1-0.7,1.2s0.8,0.2,1.4-0.3S-6.6-7.6-6.8-7.9 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_672",
    transform: "translate(3.479 15.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1772",
    fill: "#4C4C4C",
    d: "M-8.1,6l-0.2,0C-8,1.1-9-7.9-9-8l0.2,0C-8.8-7.9-7.8,1.1-8.1,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_673",
    transform: "translate(2.236 31.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1773",
    fill: "#4C4C4C",
    d: "M-9-8c0,0,0.1,0.4,0.3,1C-8.6-6.7-8.4-6.4-8.3-6C-8.2-5.8-8.1-5.5-8-5.3 c0,0.1,0.1,0.2,0.2,0.3l0.2,0.4c0.3,0.5,0.6,1,0.9,1.5c0.4,0.5,0.8,1,1.3,1.5c0.5,0.5,1.1,0.8,1.8,1.1c0.7,0.3,1.4,0.4,2.1,0.4 c0.2,0,0.4,0,0.5,0s0.4,0,0.5-0.1c0.4-0.1,0.7-0.2,1-0.3C1.4-0.8,2-1.2,2.5-1.6C3-2.1,3.4-2.6,3.8-3.1c0.3-0.5,0.7-1,0.9-1.5 C4.9-4.8,5-5.1,5.1-5.3S5.3-5.7,5.4-6C5.6-6.4,5.7-6.7,5.8-7C6-7.7,6.1-8,6.1-8S6.1-7.6,5.9-7C5.8-6.7,5.7-6.3,5.5-5.9 C5.4-5.7,5.4-5.5,5.2-5.2C5.1-5,5-4.8,4.9-4.5C4.6-4,4.3-3.5,3.9-3C3.5-2.5,3.1-2,2.6-1.5C2-1,1.4-0.6,0.8-0.4 C0.4-0.2,0.1-0.1-0.3-0.1C-0.5,0-0.7,0-0.9,0C-1,0-1.2,0-1.4,0c-0.7,0-1.5-0.1-2.2-0.4C-4.3-0.6-4.9-1-5.4-1.5 c-0.5-0.5-1-1-1.4-1.5c-0.4-0.5-0.7-1-0.9-1.5C-7.9-4.8-8-5-8.1-5.2c-0.1-0.2-0.2-0.5-0.3-0.7C-8.5-6.3-8.7-6.7-8.7-7 C-8.9-7.6-9-8-9-8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_674",
    transform: "translate(1.464 3.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1774",
    fill: "#4C4C4C",
    d: "M-8.3-0.6c-0.9-0.1-0.6-3.6-0.6-4c0-1.3,0.5-2.5,1.4-3.4l0.1,0.1 C-8.3-7-8.8-5.8-8.8-4.6c-0.1,1.4-0.1,3.8,0.5,3.8L-8.3-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_675",
    transform: "translate(15.176 2.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1775",
    fill: "#F1F2F2",
    d: "M-6.8-6.4C-7-6.1-7.7-6.2-8.2-6.6s-0.9-1-0.7-1.2S-8.1-8-7.5-7.6 S-6.6-6.6-6.8-6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_676",
    transform: "translate(2.203 2.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1776",
    fill: "#F1F2F2",
    d: "M-8.9-6.4c0.2,0.3,0.8,0.2,1.4-0.3s0.9-1,0.7-1.2S-7.6-8-8.2-7.6 S-9.1-6.6-8.9-6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_677",
    transform: "translate(2.595 6.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1777",
    fill: "#3A3A3A",
    d: "M-1.8,0.5c-2.2,0-4.3,0.4-6.4,1c-0.2-2-0.4-4.1-0.8-6.1C-7.2-8.1-1.8-8-1.8-8 s5.4,0,7.2,3.4C5-2.6,4.8-0.6,4.6,1.4C2.5,0.8,0.4,0.5-1.8,0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_678",
    transform: "translate(4.161 29.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1778",
    fill: "#3A3A3A",
    d: "M-3.4-0.3c-2,0.1-3.9-0.5-5.4-1.7L-9-8c1.3,0.6,5.6,0.7,5.6,0.7S0.9-7.4,2.3-8 L2.1-2C0.5-0.8-1.4-0.2-3.4-0.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2c5506b0b7c556de769cad950fb5a45a.svg";
export { ForwardRef as ReactComponent };